"use strict";
import Swiper from '/../../main/node_modules/swiper';
import helpers from "./_helpers";
// Add below if you need any modules
import {Navigation, Autoplay, Pagination, Parallax} from '/../../main/node_modules/swiper/modules';

const Sliders = () => {
    const init = () => {

        $(document).ready(function() {

            // EXAMPLE
            // var $image_gallery_slider_container = $('.js-image-gallery-slider-container');
            // if ($image_gallery_slider_container.length > 0) {
            //
            //     $image_gallery_slider_container.each(function () {
            //         var $image_gallery_slider = new Swiper(this, {
            //             modules: [Navigation, Pagination, Autoplay],
            //             loop: true,
            //             autoplay: false,
            //             pagination: {
            //                 el: $(this).find('.js-slider-pagination')[0],
            //                 clickable: true,
            //             },
            //             navigation: {
            //                 nextEl: $(this).find('.js-slider-next')[0],
            //                 prevEl: $(this).find('.js-slider-prev')[0],
            //             },
            //             breakpoints: {
            //                 992: {
            //                     slidesPerView: 2,
            //                     spaceBetween: 20
            //                 }
            //             }
            //         });
            //     });
            // }


            var $image_gallery_slider_container = $('.js-image-gallery-slider-container');
            if ($image_gallery_slider_container.length > 0) {

                $image_gallery_slider_container.each(function () {
                    var bar = $(this).find('.js-swiper-progress-bar');
                    var current_slide = $(this).find('.js-swiper-current');
                    var isDimensions = $(this).hasClass('style-dimensions')

                    var settings = {
                        modules: [Navigation, Autoplay, Parallax],
                        parallax: true,
                        watchOverflow: true,
                        speed: 600,
                        centeredSlides: isDimensions ? false : true,
                        slidesPerView: '1',
                        spaceBetween: '1',
                        loop: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        },
                        navigation: {
                            nextEl: $(this).find('.js-slider-next')[0],
                            prevEl: $(this).find('.js-slider-prev')[0],
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: isDimensions ? 3 : 1
                            },
                            1200: {
                                slidesPerView: isDimensions ? 4 : 1
                            }
                        },
                        on: {
                            autoplayTimeLeft(swiper, time, progress) {
                                if (swiper.autoplay.running && !swiper.autoplay.paused) {
                                    var percentTime = sanitisePercentage(100 - Math.round(time / swiper.params.autoplay.delay * 100));
                                    $(bar).css('width', percentTime + '%');
                                }
                            },
                            slideChange: function (swiper) {
                                bar.css('width', 0);
                                current_slide.text((1 + swiper.realIndex).toString().padStart(2, '0'));
                            }
                        }
                    };

                    var $image_gallery_slider = new Swiper(this, settings);

                    // setTimeout(function(){
                    //     $image_gallery_slider.slideNext();
                    // }, 100);
                });
            }

            var $link_slider_container = $('.js-link-slider-container');
            var link_slider_array = [];

            if ($link_slider_container.length > 0) {
                $link_slider_container.each(function (index) {
                    var slider = this;
                    var mobile_format = $(this).attr('data-mobile-format');
                    var desktop_format = $(this).attr('data-desktop-format');

                    linkSliderInit(slider, mobile_format, desktop_format, index);

                    window.addEventListener('load', function() {
                        linkSliderInit(slider, mobile_format, desktop_format, index);
                    });
                    window.addEventListener('resize', function() {
                        linkSliderInit(slider, mobile_format, desktop_format, index);
                    });
                });
            }

            function linkSliderInit(slider, mobile_format, desktop_format, index) {
                let mobile_bp = window.matchMedia('(min-width: 0px) and (max-width: 1023px)');
                let desktop_bp = window.matchMedia('(min-width: 1024px)');
                var is_initialised = $(slider).hasClass('swiper-initialized');
                var link_should_initialise = false;

                $(slider).removeClass('js-link-slider-accordion link-slider-accordion');

                var $copy_container = $(slider).parents('.js-module-link-slider').find('.js-module-heading-copy');
                var $next_button = $(slider).parents('.js-module-link-slider').find('.js-slider-next');
                var $prev_button = $(slider).parents('.js-module-link-slider').find('.js-slider-prev');

                if(mobile_bp.matches) {
                    if(mobile_format == 'slider') {
                        link_should_initialise = true;
                    } else {
                        link_should_initialise = false;

                        if(mobile_format == 'accordion') {
                            $(slider).addClass('js-link-slider-accordion link-slider-accordion');
                        }
                    }
                } else if(desktop_bp.matches) {
                    if(desktop_format == 'slider') {
                        link_should_initialise = true;
                    } else {
                        link_should_initialise = false;
                    }
                }

                if(link_should_initialise && !is_initialised) {
                    $(slider).removeClass('no-slider');

                    $copy_container.addClass('has-controls');
                    $next_button.removeClass('swiper-button-lock');
                    $prev_button.removeClass('swiper-button-lock');

                    var settings = {
                        modules: [Navigation, Autoplay],
                        loop: true,
                        watchOverflow: true,
                        slidesPerView: 1,
                        navigation: {
                            nextEl: $next_button[0],
                            prevEl: $prev_button[0],
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: 2,
                            },
                            1200: {
                                slidesPerView: $(slider).attr('data-desktop-slide-count'),
                            }
                        }
                    };

                    if($(slider).attr('data-desktop-slide-count') == 5) {
                        settings['breakpoints'] = {
                            767: {
                                slidesPerView: 2,
                            },
                            1200: {
                                slidesPerView: 4,
                            },
                            1500: {
                                slidesPerView: $(slider).attr('data-desktop-slide-count'),
                            }
                        };
                    }

                    if($(slider).attr('data-autoscroll') == 'true') {
                        settings['autoplay'] = {
                            delay: 5000,
                            disableOnInteraction: false,
                        };
                    }

                    var $link_slider = new Swiper(slider, settings);
                    link_slider_array[index] = $link_slider;
                    is_initialised = true;
                }

                if(!link_should_initialise) {
                    $copy_container.removeClass('has-controls');
                    $next_button.addClass('swiper-button-lock');
                    $prev_button.addClass('swiper-button-lock');
                    $(slider).addClass('no-slider');

                    if (is_initialised) {
                        var $link_slider = link_slider_array[index];
                        $link_slider.destroy();
                    }
                }
            }

            var $selectable_articles_slider_container = $('.js-selectable-articles-slider-container');
            if ($selectable_articles_slider_container.length > 0) {
                $selectable_articles_slider_container.each(function () {
                    var settings = {
                        modules: [Navigation],
                        watchOverflow: true,
                        loop: true,
                        slidesPerView: 1,
                        navigation: {
                            nextEl: $(this).parents('.js-selectable-articles-slider').find('.js-slider-next')[0],
                            prevEl: $(this).parents('.js-selectable-articles-slider').find('.js-slider-prev')[0],
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: 2,
                            },
                            1200: {
                                slidesPerView: 3,
                            }
                        }
                    };

                    var $selectable_articles_slider = new Swiper(this, settings);
                });
            }

            var $product_catalogue_slider_container = $('.js-product-catalogue-slider-container');
            if ($product_catalogue_slider_container.length > 0) {
                $product_catalogue_slider_container.each(function () {
                    var settings = {
                        modules: [Navigation],
                        watchOverflow: true,
                        loop: true,
                        slidesPerView: 1,
                        navigation: {
                            nextEl: $(this).parents('.js-module-catalogue-group').find('.js-slider-next')[0],
                            prevEl: $(this).parents('.js-module-catalogue-group').find('.js-slider-prev')[0],
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: 2,
                            },
                            1200: {
                                slidesPerView: $(this).attr('data-desktop-slide-count')
                            }
                        }
                    };

                    var $product_catalogue_slider = new Swiper(this, settings);
                });
            }

            var $agent_slider_container = $('.js-agent-slider-container');

            if ($agent_slider_container.length > 0) {
                $agent_slider_container.each(function (index) {
                    var slider = this;

                    helpers.agentSliderInit(slider, index);

                    window.addEventListener('load', function() {
                        helpers.agentSliderInit(slider, index);
                    });
                    window.addEventListener('resize', function() {
                        helpers.agentSliderInit(slider, index);
                    });
                });
            }

            var $product_variant_slider_container = $('.js-product-variant-slider-container');
            if ($product_variant_slider_container.length > 0) {
                $product_variant_slider_container.each(function () {

                    var settings = {
                        modules: [Navigation],
                        watchOverflow: true,
                        loop: true,
                        slidesPerView: 1,
                        navigation: {
                            nextEl: $(this).find('.js-slider-next')[0],
                            prevEl: $(this).find('.js-slider-prev')[0],
                        }
                    };

                    var $product_variant_slider = new Swiper(this, settings);
                });
            }
        });
    };

    // https://curtistimson.co.uk/post/js/default-negative-variables-to-zero-in-javascript/
    function sanitisePercentage(i) {
        return Math.min(100, Math.max(0, i));
    }

    return {
        init:init
    };
};

export default Sliders;